import type { AreaSummary } from '@/types/area'

const SUFIJO_PREDEFINIDA = ' (Predefinido)'

/** Detecta el área predefinida "General" (por slug; cae a nombre si no hay slug). */
export function esAreaGeneral(area: { nombre?: string | null; slug?: string | null }): boolean {
  const slug = area.slug?.trim().toLowerCase()
  if (slug) return slug === 'general'
  return (area.nombre ?? '').trim().toLowerCase() === 'general'
}

/** Nombre del área con sufijo "(Predefinido)" si es la General. */
export function formatNombreArea(area: { nombre: string; slug?: string | null }): string {
  return esAreaGeneral(area) ? `${area.nombre}${SUFIJO_PREDEFINIDA}` : area.nombre
}

/** Ordena: General primera, resto alfabético (es). No muta la entrada. */
export function ordenarAreas<T extends { nombre: string; slug?: string | null }>(areas: T[]): T[] {
  return [...areas].sort((a, b) => {
    const ga = esAreaGeneral(a), gb = esAreaGeneral(b)
    if (ga !== gb) return ga ? -1 : 1
    return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
  })
}

// Re-export del tipo para conveniencia
export type { AreaSummary }
